"use client"
import { IconId } from "@tabler/icons-react";
import React from "react";
import InputMask from "react-input-mask";

interface Props {
  register: any;
  name: string;
  mask: string;
  ref: any;
  placeholder?: string;
  customClass?: string
}

const MaskInput = (props: Props) => {
  const { 
    register, 
    name, 
    mask, 
    ref, 
    placeholder, 
    customClass = 'w-full focus:outline-none border border-grayForm rounded-md text-graySoft py-2 px-2 pl-10' 
  } = props;
  return (
    <div className="input-icon relative ">
      
      <InputMask
        {...register(name, { required: true })}
        className={customClass}
        mask={mask}
        inputRef={ref}
        placeholder={placeholder}
        alwaysShowMask={false}
        maskChar=''
      />
    </div>
  );
};

export default MaskInput;
